import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_TAXES_URL = `${process.env.PUBLIC_URL}/api/v1/r/taxes`;

export const GET_TAXES = 'GET_TAXES';
export const GET_TAXES_COMPLETED = 'GET_TAXES_COMPLETED';
export const GET_TAXES_FAILED = 'GET_TAXES_FAILED';
export function getTaxes({salonId}) {
  const filter = {
    where: {
      salonId: {eq: salonId}
    },
  };
  return queryAll(GET_TAXES_URL, filter, GET_TAXES, GET_TAXES_COMPLETED, GET_TAXES_FAILED);
}

export const SEARCH_TAXES = 'SEARCH_TAXES';
export const SEARCH_TAXES_COMPLETED = 'SEARCH_TAXES_COMPLETED';
export const SEARCH_TAXES_FAILED = 'SEARCH_TAXES_FAILED';
export const searchTaxes = querySearch(GET_TAXES_URL, SEARCH_TAXES, SEARCH_TAXES_COMPLETED, SEARCH_TAXES_FAILED,
  ['name', 'description', 'registrationNumber']);

export const GET_TAX = 'GET_TAX';
export const GET_TAX_COMPLETED = 'GET_TAX_COMPLETED';
export const GET_TAX_FAILED = 'GET_TAX_FAILED';
export function getTax({taxId}) {
  return queryOne(GET_TAXES_URL, {where: {taxId}}, GET_TAX, GET_TAX_COMPLETED, GET_TAX_FAILED);
}

const GET_TAXES_RATES_URL = `${process.env.PUBLIC_URL}/api/v1/r/taxesRates`;

export const GET_TAXES_RATES = 'GET_TAXES_RATES';
export const GET_TAXES_RATES_COMPLETED = 'GET_TAXES_RATES_COMPLETED';
export const GET_TAXES_RATES_FAILED = 'GET_TAXES_RATES_FAILED';
export function getTaxesRates({salonId}) {
  return queryAll(GET_TAXES_RATES_URL, {where:{salonId}}, GET_TAXES_RATES, GET_TAXES_RATES_COMPLETED,
    GET_TAXES_RATES_FAILED);
}

export const GET_TAX_RATES = 'GET_TAX_RATES';
export const GET_TAX_RATES_COMPLETED = 'GET_TAX_RATES_COMPLETED';
export const GET_TAX_RATES_FAILED = 'GET_TAX_RATES_FAILED';
export function getTaxRates({taxId}) {
  const filter = {
    where: {taxId}
  };
  return queryAll(GET_TAXES_RATES_URL, filter, GET_TAX_RATES, GET_TAX_RATES_COMPLETED, GET_TAX_RATES_FAILED);
}

const GET_TAX_GROUPS_URL = `${process.env.PUBLIC_URL}/api/v1/r/taxGroups`;
export const GET_TAX_GROUPS = 'GET_TAX_GROUPS';
export const GET_TAX_GROUPS_COMPLETED = 'GET_TAX_GROUPS_COMPLETED';
export const GET_TAX_GROUPS_FAILED = 'GET_TAX_GROUPS_FAILED';
export function getTaxGroups({salonId}) {
  const filter = {
    where: {salonId}
  };
  return queryAll(GET_TAX_GROUPS_URL, filter, GET_TAX_GROUPS, GET_TAX_GROUPS_COMPLETED, GET_TAX_GROUPS_FAILED);
}

export const SEARCH_TAX_GROUPS = 'SEARCH_TAX_GROUPS';
export const SEARCH_TAX_GROUPS_COMPLETED = 'SEARCH_TAX_GROUPS_COMPLETED';
export const SEARCH_TAX_GROUPS_FAILED = 'SEARCH_TAX_GROUPS_FAILED';
export const searchTaxGroups = querySearch(GET_TAX_GROUPS_URL, SEARCH_TAX_GROUPS, SEARCH_TAX_GROUPS_COMPLETED,
  SEARCH_TAX_GROUPS_FAILED, 'name');

export const GET_TAX_GROUP = 'GET_TAX_GROUP';
export const GET_TAX_GROUP_COMPLETED = 'GET_TAX_GROUP_COMPLETED';
export const GET_TAX_GROUP_FAILED = 'GET_TAX_GROUP_FAILED';
export function getTaxGroup({taxGroupId}) {
  return queryOne(GET_TAX_GROUPS_URL, {where:{taxGroupId}}, GET_TAX_GROUP, GET_TAX_GROUP_COMPLETED, GET_TAX_GROUP_FAILED);
}

const TAX_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/tax`;
export const ADD_TAX = 'ADD_TAX';
export const ADD_TAX_COMPLETED = 'ADD_TAX_COMPLETED';
export const ADD_TAX_FAILED = 'ADD_TAX_FAILED';
export const addTax = command(TAX_ACTION_URL + '/addTax', ADD_TAX, ADD_TAX_COMPLETED, ADD_TAX_FAILED);

export const UPDATE_TAX_RATE = 'UPDATE_TAX_RATE';
export const UPDATE_TAX_RATE_COMPLETED = 'UPDATE_TAX_RATE_COMPLETED';
export const UPDATE_TAX_RATE_FAILED = 'UPDATE_TAX_RATE_FAILED';
export const updateTaxRate = command(TAX_ACTION_URL + '/updateTaxRate', UPDATE_TAX_RATE, UPDATE_TAX_RATE_COMPLETED,
  UPDATE_TAX_RATE_FAILED);

const TAX_GROUP_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/taxGroup`;
export const ADD_TAX_GROUP = 'ADD_TAX_GROUP';
export const ADD_TAX_GROUP_COMPLETED = 'ADD_TAX_GROUP_COMPLETED';
export const ADD_TAX_GROUP_FAILED = 'ADD_TAX_GROUP_FAILED';
export const addTaxGroup = command(TAX_GROUP_ACTION_URL + '/addTaxGroup', ADD_TAX_GROUP, ADD_TAX_GROUP_COMPLETED,
  ADD_TAX_GROUP_FAILED);

export const UPDATE_TAX_GROUP = 'UPDATE_TAX_GROUP';
export const UPDATE_TAX_GROUP_COMPLETED = 'UPDATE_TAX_GROUP_COMPLETED';
export const UPDATE_TAX_GROUP_FAILED = 'UPDATE_TAX_GROUP_FAILED';
export const updateTaxGroup = command(TAX_GROUP_ACTION_URL + "/updateTaxGroup", UPDATE_TAX_GROUP,
  UPDATE_TAX_GROUP_COMPLETED, UPDATE_TAX_GROUP_FAILED);

export const ADD_TAX_TO_GROUP = 'ADD_TAX_TO_GROUP';
export const ADD_TAX_TO_GROUP_COMPLETED = 'ADD_TAX_TO_GROUP_COMPLETED';
export const ADD_TAX_TO_GROUP_FAILED = 'ADD_TAX_TO_GROUP_FAILED';
export const addTaxToGroup = command(TAX_GROUP_ACTION_URL + "/addTaxToGroup", ADD_TAX_TO_GROUP,
  ADD_TAX_TO_GROUP_COMPLETED, ADD_TAX_TO_GROUP_FAILED);

export const REMOVE_TAX_FROM_GROUP = 'REMOVE_TAX_FROM_GROUP';
export const REMOVE_TAX_FROM_GROUP_COMPLETED = 'REMOVE_TAX_FROM_GROUP_COMPLETED';
export const REMOVE_TAX_FROM_GROUP_FAILED = 'REMOVE_TAX_FROM_GROUP_FAILED';
export const removeTaxFromGroup = command(TAX_GROUP_ACTION_URL + "/removeTaxFromGroup", REMOVE_TAX_FROM_GROUP,
  REMOVE_TAX_FROM_GROUP_COMPLETED, REMOVE_TAX_FROM_GROUP_FAILED);

export const UPDATE_TAX = 'UPDATE_TAX';
export const UPDATE_TAX_COMPLETED = 'UPDATE_TAX_COMPLETED';
export const UPDATE_TAX_FAILED = 'UPDATE_TAX_FAILED';
export const updateTax = command(TAX_ACTION_URL + '/updateTax', UPDATE_TAX, UPDATE_TAX_COMPLETED, UPDATE_TAX_FAILED);



// WEBPACK FOOTER //
// ./src/Tax/actions.js